// @ts-ignore
import * as ramda from 'ramda';

import type {FilterObject} from './types';

/**
 * Encodes brackets in filter names to prevent Symfony from parsing them as array notation.
 * Symfony automatically interprets filter[[name]] and filter%5B%5Bname%5D%5D as nested arrays,
 * which breaks filters with literal brackets in their names.
 *
 * Decoded in frontend in client/core/filter.js decodeFilterNameBrackets()
 * Decoded in backend in RestBundle/ControllerTrait/Pageable.php decodeFilterNameBrackets()
 *
 * @param {string} filterName - The name of the filter to serialize.
 * @returns {string} - The serialized filter name.
 */
function encodeFilterNameBrackets(filterName: string): string {
    return filterName.replace(/\[/g, '__LBRACKET__').replace(/\]/g, '__RBRACKET__');
}

/**
 * Converts an array of filter objects to a format appropriate for an ajax
 * request.
 *
 * @param {Object[]} filters - An array of objects where each item represents a single
 *                      filter
 * @return {Object} - An object representation of the filters where each filter
 *                  is represented by a single key.
 */
export function serializeFilters(filters: Array<FilterObject>) {
    return filters.reduce<Record<string, any>>((serFilter, filter) => {
        // Basic assumption here that there is only a single key per filter
        const filterName = Object.keys(filter)[0];
        // @ts-ignore
        const encodedFilterName = encodeFilterNameBrackets(filterName);

        serFilter[encodedFilterName] = ramda.has(encodedFilterName)(serFilter)
            ? // @ts-ignore
              ramda.flatten([serFilter[encodedFilterName], filter[filterName]])
            : // @ts-ignore
              filter[filterName];

        return serFilter;
    }, {});
}
